import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type IHelp from '@/interfaces/api-resources/Dara/Help'
import type IDataResponse from '@/interfaces/api-resources/DataResponse'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/help`
  },

  get(routeName: string) {
    const params = new URLSearchParams({
      application: 'MyHQv3',
      url: routeName,
    })

    return axios.get<IDataResponse<IHelp>, IDataResponse<IHelp>>(`${ this.baseUrl() }?${ params.toString() }`)
      .then(data => data.data)
      .catch(() => {
        throw new Error('Failed to fetch help for: ' + routeName)
      })
  },

  getDocs(routeName: string) {
    const params = new URLSearchParams({
      application: 'MyHQv3',
      url: routeName,
    })

    return axios.get<IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>, IDataResponse<Domain.ResourceLibrary.Resources.ApiV3.LibraryFileResource[]>>(`${ this.baseUrl() }/docs?${ params.toString() }`)
      .then(data => data.data)
      .catch(() => {
        throw new Error('Failed to fetch help docs for: ' + routeName)
      })
  },
}
